// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import "babel-polyfill"
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import breadcrumb from './components/assembly/breadcrumb'
import 'element-ui/lib/theme-chalk/index.css'
import '../static/css/salesmanEntry.scss'
import api from './util/api'
import config from './util/config'
import axios from './config/axios.config'
import '../static/css/base.css'

import "../plugins/ztree/js/jquery.ztree.core.min.js";
import "../plugins/ztree/js/jquery.ztree.excheck.min.js";

// 懒加载图片
import VueLazyLoad from 'vue-lazyload'
Vue.use(VueLazyLoad, {
  // error: require('./assets/map.png'),
  loading: require('./assets/jz.jpg')
})

import VueQuillEditor from 'vue-quill-editor';
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';
import Quill from 'quill'; // 引入编辑器
import { ImageDrop } from 'quill-image-drop-module';
import ImageResize from 'quill-image-resize-module';
Quill.register('modules/imageDrop', ImageDrop);
Quill.register('modules/imageResize', ImageResize);
Vue.use(VueQuillEditor);



//引入ue
/*import '../static/ueditor/ueditor.config.js'
import '../static/ueditor/ueditor.all.min.js'
import '../static/ueditor/lang/zh-cn/zh-cn.js'
import '../static/ueditor/ueditor.parse.min.js'*/

Vue.prototype.api = api;
Vue.prototype.config = config;
Vue.prototype.axios = axios;
Vue.component(breadcrumb.name, breadcrumb);
String.prototype.trim = function () { return this.replace(/(^\s*)|(\s*$)/g, "") }
Vue.use(ElementUI);
Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js